import React from 'react';
import { Form } from 'redux-form';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';

const StampExamForm = ({
  materia,
  fecha,
  fechaInicioReclamo,
  fechaFinReclamo,
  onChange,
  mode,
}) => (
  <Form className="form">
    <Row>
      <Col md={12}>
        <p>
          {mode === 'confirmGrades'
            ? (
              <>
                Se van a confirmar las notas del examen de{' '}
                <strong>{materia}</strong> del <strong>{fecha}</strong>.
              </>
            )
            : (
              <>
                Se va a sellar el examen de{' '}
                <strong>{materia}</strong> del <strong>{fecha}</strong>.
              </>
            )
          }
        </p>
        <p>
          Debes definir la ventana de solicitud de revisión antes de{' '}
          {mode === 'confirmGrades' ? 'confirmar' : 'sellar'}.
        </p>
      </Col>

      <Col md={6}>
        <div className="form__form-group">
          <span className="form__form-group-label required">Inicio solicitud de revisión</span>
          <div className="form__form-group-field">
            <input
              name="fechaInicioReclamo"
              placeholder="Inicio solicitud de revisión"
              autoComplete="false"
              type="datetime-local"
              value={fechaInicioReclamo || ''}
              onChange={e => onChange('fechaInicioReclamo', e.target.value)}
              className="form-control"
            />
          </div>
        </div>
      </Col>

      <Col md={6}>
        <div className="form__form-group">
          <span className="form__form-group-label required">Fin solicitud de revisión</span>
          <div className="form__form-group-field">
            <input
              name="fechaFinReclamo"
              placeholder="Fin solicitud de revisión"
              autoComplete="false"
              type="datetime-local"
              value={fechaFinReclamo || ''}
              onChange={e => onChange('fechaFinReclamo', e.target.value)}
              className="form-control"
            />
          </div>
        </div>
      </Col>
    </Row>
  </Form>
);

StampExamForm.propTypes = {
  materia: PropTypes.string,
  fecha: PropTypes.string,
  fechaInicioReclamo: PropTypes.string,
  fechaFinReclamo: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  mode: PropTypes.oneOf(['stamp', 'confirmGrades']),
};

StampExamForm.defaultProps = {
  materia: '',
  fecha: '',
  mode: 'stamp',
  fechaInicioReclamo: '',
  fechaFinReclamo: '',
};

export default StampExamForm;
